

import { GetInstitutionsByUser, GetInstitutionsByUserResponse } from '@/api/dtos';
import { SWRConfiguration, SWRResponse } from 'swr';
import useGet from '../api/useGet';
import { useMemo } from 'react';

const getData = (response?: SWRResponse<GetInstitutionsByUserResponse, GetInstitutionsByUserResponse>) => response?.data?.instituions;
const getError = (response?: SWRResponse<GetInstitutionsByUserResponse, GetInstitutionsByUserResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useInstitutionsByUser = (configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        return () => {
            return new GetInstitutionsByUser();
        }
    }, []);

    return useGet(request, { getData, getError }, configuration);
}

export default useInstitutionsByUser;